import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import {
  roles,
  viewPathConstants,
  CenterStatusEnum,
  freelanceStatusEnum,
} from "../../../constants";

const ProtectedRoute = ({ isProtected, children }) => {
  const isAuthenticated = useSelector(
    (state) => state.LoginReducer.isAuthenticated
  );
  const isLoginFromRegForm = useSelector(
    (state) => state.LoginReducer.isLoginFromRegForm
  );
  const UserData = useSelector((state) => state.LoginReducer.UserData);

  if (isAuthenticated && !isProtected) {
    if (isLoginFromRegForm) {
      return;
    }
    if (
      roles.Admin === UserData?.user?.role ||
      roles.SuperAdmin === UserData?.user?.role
    ) {
      return <Navigate to={viewPathConstants.USERS} replace />;
    } else if (roles.Instructor === UserData?.user?.role) {
      return <Navigate to={viewPathConstants.PROFILE} replace />;
    } else if (
      roles.FreelanceInstructor === UserData?.user?.role &&
      (UserData?.freelanceStatus === freelanceStatusEnum.PaymentRejected ||
        UserData?.freelanceStatus === freelanceStatusEnum.Restricted ||
        UserData?.freelanceStatus === freelanceStatusEnum.PaymentPending)
    ) {
      return (
        <Navigate to={viewPathConstants.FREELANCE_PENDING_PAYMENT} replace />
      );
    } else if (roles.FreelanceInstructor === UserData?.user?.role) {
      return <Navigate to={viewPathConstants.PROFILE} replace />;
    } else if (
      roles.Center === UserData?.user?.role &&
      (UserData.centerStatus === CenterStatusEnum.PaymentPending ||
        UserData.centerStatus === CenterStatusEnum.PaymentRejected ||
        UserData.centerStatus === CenterStatusEnum.Restricted)
    ) {
      return <Navigate to={viewPathConstants.CENTER_PENDING_PAYMENT} replace />;
    } else if (roles.Center === UserData?.user?.role) {
      return <Navigate to={viewPathConstants.CENTER_PROFILE} replace />;
    } else {
      return <Navigate to={viewPathConstants.DASHBOARD} replace />;
    }
  } else if (!isAuthenticated && isProtected) {
    return <Navigate to={viewPathConstants.DEFAULT_PATH} replace />;
  }
  return children;
};

export default React.memo(ProtectedRoute);
